var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScorecard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0004 12.1048C22.0004 14.0827 21.4138 16.0162 20.315 17.6608C19.2161 19.3053 17.6543 20.5871 15.8269 21.344C13.9996 22.1009 11.9888 22.299 10.049 21.9131C8.10906 21.5272 6.32716 20.5748 4.92857 19.1762C3.52999 17.7776 2.57754 15.9957 2.19167 14.0558C1.8058 12.1159 2.00384 10.1052 2.76075 8.27785C3.51766 6.45051 4.79944 4.88865 6.444 3.78979C8.08856 2.69093 10.022 2.10442 11.9999 2.10442C13.3132 2.10442 14.6136 2.36309 15.8269 2.86566C17.0402 3.36822 18.1427 4.10485 19.0713 5.03348C19.9999 5.9621 20.7366 7.06454 21.2391 8.27785C21.7417 9.49115 22.0004 10.7916 22.0004 12.1048ZM18.1098 9.58737L16.2505 9.36758L14.3747 9.14526L12.7995 5.72968C12.3637 4.7861 11.6526 4.7861 11.2168 5.72968L9.64162 9.14526L7.76583 9.36758L5.90773 9.58737C4.87573 9.70989 4.65594 10.3869 5.41888 11.0931L6.7932 12.3638L8.18015 13.6459L7.81131 15.4989L7.44625 17.3343C7.24415 18.3537 7.82015 18.7718 8.7271 18.2653L12.0088 16.4274L15.2905 18.2653C16.1961 18.7718 16.7721 18.3537 16.57 17.3343L15.8374 13.6459L17.2231 12.3638L18.5987 11.0931C19.3616 10.3869 19.1418 9.70989 18.1098 9.58737Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScorecard);
export default __webpack_public_path__ + "static/media/scorecard.fd6f5f1f04daf5d11441223183944c35.svg";
export { ForwardRef as ReactComponent };